export const some = [
  {
    startTime: '2020-08-01T20:00:00.000Z',
    venue: 'Scotiabank Arena',
    teams: [
      {
        id: '693f5a142bed6174b9f84ce91daf77760a50b202',
        name: 'Islanders',
        city: 'New York',
        logo: 'https://assets.boomfantasy.com/timHortons/teams/ny_islanders.svg',
        abbr: 'NYI',
      },
      {
        id: '9448e06a93e22faf9960a61c2bc5f59a2333a3ea',
        name: 'Panthers',
        city: 'Florida',
        logo: 'https://assets.boomfantasy.com/timHortons/teams/florida.svg',
        abbr: 'FLA',
      },
    ],
    started: false,
  },
  {
    startTime: '2020-08-01T19:00:00.000Z',
    venue: 'Rogers Place',
    teams: [
      {
        id: 'd5cec58442d75d8010bbe065fa380bbb65a9e9d4',
        name: 'Oilers',
        city: 'Edmonton',
        logo: 'https://assets.boomfantasy.com/timHortons/teams/edmonton.svg',
        abbr: 'EDM',
      },
      {
        id: 'd9c513e7ed81b7001f9a8e147da8a978b2e50e59',
        name: 'Blackhawks',
        city: 'Chicago',
        logo: 'https://assets.boomfantasy.com/timHortons/teams/chicago.svg',
        abbr: 'CHI',
      },
    ],
    started: false,
  },
  {
    startTime: '2020-08-01T16:00:00.000Z',
    venue: 'Scotiabank Arena',
    teams: [
      {
        id: 'b184c1e18582d910757b0a71cb1d813dbae85a44',
        name: 'Hurricanes',
        city: 'Carolina',
        logo: 'https://assets.boomfantasy.com/timHortons/teams/carolina.svg',
        abbr: 'CAR',
      },
      {
        id: '35c8db3619ac07ce4abdba85635fc26f77d2ef03',
        name: 'Rangers',
        city: 'New York',
        logo: 'https://assets.boomfantasy.com/timHortons/teams/ny_rangers.svg',
        abbr: 'NYR',
      },
    ],
    started: false,
  },
];
